var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _ellipse, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _path16, _path17, _path18, _path19, _path20, _ellipse2, _path21, _path22, _path23, _path24, _circle3, _path25, _circle4, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1002,
    height: 121,
    viewBox: "0 0 1002 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.744 68.4712C528.755 67.028 521.539 82.8799 521.539 90.577V103.566H584.68C582.515 103.205 585.401 100.102 578.185 90.577C570.969 81.0518 563.873 86.6082 561.227 90.577C558.822 84.0826 554.733 69.9144 541.744 68.4712Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.07 81.5196C479.007 80.6021 471.75 90.6798 471.75 95.5732V103.831H535.251C533.074 103.601 535.977 101.629 528.72 95.5732C521.463 89.5176 514.326 93.05 511.665 95.5732C509.246 91.4444 505.134 82.4371 492.07 81.5196Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.32 81.5196C331.257 80.6021 324 90.6798 324 95.5732V103.831H387.501C385.324 103.601 388.227 101.629 380.97 95.5732C373.713 89.5176 366.576 93.05 363.915 95.5732C361.496 91.4444 357.384 82.4371 344.32 81.5196Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 104H604",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.691,
    cy: 48.2661,
    r: 23.813,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.69 107.077V56.9258",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.114,
    cy: 58.3677,
    r: 23.813,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.114 117.179V67.0273",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.319,
    cy: 54.7606,
    rx: 17.3186,
    ry: 30.3075,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M457.316 110.521V74.0469",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.766 99.5L272.766 103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M304.52 94.4492V103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M266.996 94.4492V103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8823 94.4492V103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3359 48.2659L100.218 2.80469L139.991 48.2659",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2734 50.4282L81.9016 35.9961V96.6111",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.911 1H200.245L229.47 39.2452",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.531 54.3984V93.0044",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 38.8828,
    width: 12.9889,
    height: 13.7105,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 56.2031,
    width: 25.2562,
    height: 13.7105,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 75.6875,
    width: 12.9889,
    height: 20.9266,
    fill: "#F3C477"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M133.855 53.3164V95.8912",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6562 19.7628V1.72266H86.2331V12.186",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M666.256 68.4712C679.245 67.028 686.461 82.8799 686.461 90.5771V103.566H623.32C625.485 103.205 622.599 100.102 629.815 90.5771C637.031 81.0519 644.127 86.6083 646.773 90.5771C649.178 84.0826 653.267 69.9144 666.256 68.4712Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M715.93 81.5196C728.993 80.6021 736.25 90.6798 736.25 95.5732V103.831H672.749C674.926 103.601 672.023 101.629 679.28 95.5732C686.537 89.5176 693.674 93.05 696.335 95.5732C698.754 91.4444 702.866 82.4371 715.93 81.5196Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1002 104H604",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.3186,
    ry: 30.3075,
    transform: "matrix(-1 0 0 1 750.681 54.7606)",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M750.684 110.521V74.0469",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M935.234 99.5L935.234 103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M903.48 94.4492V103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M941.004 94.4492V103.83",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 851.813,
    cy: 58.3677,
    r: 23.813,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M851.813 117.179V67.0273",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.813,
    cy: 48.813,
    r: 23.813,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M875.813 107.624V57.4727",
    stroke: "#68BFAC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.c31511d4.svg";
export { ForwardRef as ReactComponent };